import React from "react";

function VideoCard({ video, handleSelectVideo }) {
  return (
    <div
      className={`flex p-2 mb-1 w-full mx-auto cursor-pointer hover:bg-gray-500 bg-gray-600`}
      onClick={() => handleSelectVideo(video)}
    >
      <div className="flex-shrink-0">
        <img
          src={video.thumbnail}
          alt={`${video.title} thumbnail`}
          className={`max-h-10 w-auto`}
        />
      </div>
      <div className={`flex flex-col ml-4 text-left justify-center`}>
        <div className="flex">
          <div className="text-xs text-gray-100 font-bold">{video.title}</div>
        </div>
        <div className="text-[10px] text-gray-400">{video.description}</div>
      </div>
    </div>
  );
}

export default VideoCard;
